import { render } from "./addnews.vue?vue&type=template&id=34930dc2&scoped=true"
import script from "./addnews.vue?vue&type=script&lang=js"
export * from "./addnews.vue?vue&type=script&lang=js"

import "./addnews.vue?vue&type=style&index=0&id=34930dc2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34930dc2"]])

export default __exports__